import * as React from 'react';
import { ArticleParagraph1, Checkbox } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { NBSP } from '../../../../constants/symbols';
import { isAbExperiment } from '../../../../utils/abuse';
import { selectAbUseExperiments } from '../../../../selectors/selectAbUseExperiments';
import { FIND_REALTOR_FORM_START } from '../../../../constants/experiments';

import * as styles from './styles.css';

interface IAgreementsBlockProps {
  checked: boolean;
  toggleCheckbox(): void;
}

export const AgreementsBlock: React.FC<React.PropsWithChildren<IAgreementsBlockProps>> = ({
  checked,
  toggleCheckbox,
}) => {
  const isNewFormStart = isAbExperiment(useSelector(selectAbUseExperiments), FIND_REALTOR_FORM_START, 'B');
  const agreementText = isNewFormStart
    ? `Нажимая «Далее», соглашаюсь на${NBSP}`
    : `Продолжая вы${NBSP}соглашаетесь на${NBSP}`;

  const marketingText = isNewFormStart ? `рассылку с${NBSP}рекламой` : `маркетинговую коммуникацию`;

  return (
    <>
      <ArticleParagraph1>
        <span className={styles['phrase']}>{agreementText}</span>
        <a
          className={styles['link']}
          href="https://cdn.cian.site/frontend/lead-realtor-form-assets/documents/Consent_to_the_processing_of_personal_data.pdf"
          target="_blank"
          rel="noreferrer"
        >
          обработку персональных данных
        </a>
      </ArticleParagraph1>
      <div className={styles['checkbox']}>
        <Checkbox
          checked={checked}
          onChange={toggleCheckbox}
          label={
            (
              <ArticleParagraph1>
                <>
                  <span className={styles['phrase']}>Соглашаюсь получать{NBSP}</span>
                  <a
                    className={styles['link']}
                    href="https://cdn.cian.site/frontend/lead-realtor-form-assets/documents/Consent_to_receive_advertising.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {marketingText}
                  </a>
                </>
              </ArticleParagraph1>
            ) as never
          }
        />
      </div>
    </>
  );
};

AgreementsBlock.displayName = 'AgreementsBlock';
